import { IRankingsData } from "src/api/server/extended-search.types";
import { ISortDirectionType } from "src/types/common";
import { ISelectedRanking } from "../components/types";
import { SearchQueryParams } from "../search.types";
import { getUrlIdentifier } from "./get-url-identifier";

export const mapSelectedRankingFromQuery = (
    urlParams: URLSearchParams,
    sortDirection: ISortDirectionType,
    rankingsData: IRankingsData
): ISelectedRanking => {
    const selectedRanking = urlParams.get(SearchQueryParams.SortByRanking);
    const searchTerm = urlParams.get(SearchQueryParams.SearchTerm);
    if (selectedRanking) {
        return {
            id: rankingsData.rankings.find(ranking => ranking.urlIdentifier === selectedRanking)?.id ?? rankingsData.defaultSelectedRanking.id,
            sortDirection,
        };
    } else if (Boolean(searchTerm)) {
        return { id: rankingsData.relevanceRanking.id, sortDirection: rankingsData.relevanceRanking.sortDirection };
    } else {
        return { id: rankingsData.defaultSelectedRanking.id, sortDirection };
    }
};

export const mapSelectedRankingToQuery = (selectedRanking: ISelectedRanking | null, rankingsData: IRankingsData) => {
    if (selectedRanking?.id) {
        const isSelectedRankingDefault = rankingsData.defaultSelectedRanking.id === selectedRanking.id;
        if (isSelectedRankingDefault) {
            return `${SearchQueryParams.SortByRanking}=${rankingsData.defaultSelectedRanking.urlIdentifier}`;
        } else {
            const selectedRankingUrlIdentifier = getUrlIdentifier(rankingsData.rankings, selectedRanking.id);
            if (selectedRankingUrlIdentifier) {
                return `${SearchQueryParams.SortByRanking}=${selectedRankingUrlIdentifier}`;
            }
        }
    }

    return "";
};
